const routes = [
    {
        path: "/user/filters",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            isAdmin: true,
        }
    }
];

export default routes;
